<script lang="ts">
  import SellSheetBuyProductItem from "./SellSheetBuyProductItem.svelte";
  import type { SellSheet } from "@shared/types/SellSheet";

  export let showProductLinks: boolean;
  export let mobileMode: boolean;
  export let sellSheet: SellSheet;
  export let isSFList: boolean;
</script>

{#if sellSheet.product_lines.length > 0}
  <div class="grid-row margin-bottom--small">
    {#each sellSheet.product_lines as productLine}
      <div
        class="grid-col c12-12 align-left background-white dpl-row sell-sheet-preview-wrapper"
        id="product-line-{productLine.id}"
      >
        <SellSheetBuyProductItem
          {sellSheet}
          {showProductLinks}
          {productLine}
          {mobileMode}
          {isSFList}
        />
      </div>
    {/each}
  </div>
{/if}
